export enum enumCalendarEventType {
    QuotePreparation = 1,
    OrderPreparation = 2,
    OrderInstallation = 3,
    GoogleCalendar = 4,
};